<template>
  <div class="accountManagement">
    <!-- <h2>自定义菜单</h2>
    <div class="menutop">
      <div>
        <i class="el-icon-warning" style="font-size:30px" />
      </div>
      <div class="menutip">
        <div class="menuir">菜单编辑中</div>
        <div class="menutxt">菜单未发布，请确认菜单编辑完成后点击“保存并发布”同步到手机。若停用菜单，请点击这里</div>
      </div>
    </div> -->
    <div class="mainall">
      <!-- <div class="neimain">
        <i class="el-icon-warning" style="font-size:15px" />
        <div class="neitect">你已授权给自由人数据管理、自由人数据管理、阅宝、微小盟营销中心、木卫二帮助你运营公众号，点击管理已授权的第三方平台</div>
      </div> -->
      <div class="gongwer">
        <div class="menutemplate_box">
          <div>菜单模板名称：</div>
          <div><el-input v-model="menutemplateName" placeholder="请输入内容" /></div>
        </div>
        <div class="menutemplate_box">
          <div>选择平台：</div>
          <el-select v-model="allpalateid" placeholder="请选择平台" @change="changepalate">
            <el-option
              v-for="items in plateoption"
              :key="items.id"
              :label="items.name"
              :value="items.id"
            />
          </el-select>
        </div>
        <div class="menutemplate_box">
          <div>选择标签组：</div>
          <el-select v-model="tagId" placeholder="请选择标签组" @change="changeTags">
            <el-option
              v-for="items in tagslist"
              :key="items.id"
              :label="items.tag_group_name"
              :value="items.id"
            />
          </el-select>
        </div>
        <div class="menutemplate_box" style="color: red;">*创建普通菜单请选择 无（非个性化菜单）</div>
      </div>

      <div class="edit_box">
        <!-- 编辑菜单的图 -->
        <div class="mobile_menu_preview">
          <div class="mobile_hd">深圳自由人</div>

          <div class="biodaw">
            <div class="bisbox">
              <div v-for="item,index in arr" :key="index" class="menutext" :class="[item.id===active?'updataactive':'']" @click.stop="choosemenu(item,index)">
                {{ item.name }}
                <div v-if="item.showtips === true" class="menutextips">
                  <div v-for="items,indexr in item.sub_button" :key="indexr" class="submenu" :class="[items.id===sonactive?'updataactive':'']" @click.stop="sonmenuclick(items,indexr)">
                    {{ items.name }}
                  </div>
                  <div v-if="item.sub_button.length<5" class="submenuadd" @click.stop="submenuaddclick(index)">
                    +
                  </div>
                </div>
              </div>
              <!-- || arr.length!==0 -->
              <div v-if="arr.length<3 " :class="[arr.length===0?'addmenuactive':'addmenunoactive']" @click.stop="addmenu"><span>+</span><span style="font-size:14px">添加菜单</span></div>
            </div>

          </div>
        </div>
        <div v-if="bg === -1 || arr.length === 0" class="right_nobox">
          点击左侧菜单进行编辑操作
        </div>

        <!-- 旁边编辑显示的内容 -->
        <div v-else class="right_editbox">
          <div class="right_edittop">
            <div class="right_editvalue">{{ values }}</div>
            <div class="right_editvalue deletetext" @click.stop="deletmenu"><span v-if="selftype === 'parent'">删除菜单</span><span v-if="selftype === 'son'">删除子菜单</span></div>
          </div>
          <div class="right_editinput">
            <div v-if="selftype === 'parent'" class="right_editvalue">菜单名称</div>
            <div v-if="selftype === 'son'" class="right_editvalue">子菜单名称</div>
            <div>
              <el-input v-model="values" class="right_inputvalue" style="width:270px" placeholder="请输入内容" @input="changeinput" />
            </div>
          </div>
          <div class="right_tips">仅支持中英文和数字，字数不超过4个汉字或8个字母</div>

          <div v-if="arr[indexinput].sub_button.length===0 && selftype === 'parent' || selftype === 'son'">
            <div class="right_chooseradio">
              <div>
                <div v-if="selftype === 'parent'" class="right_editvalue">菜单内容</div>
                <div v-if="selftype === 'son'" class="right_editvalue">子菜单内容</div>
              </div>
              <!-- {{ radio }} -->
              <el-radio-group v-model="radio" class="right_radiobox" @change="changeradio">

                <el-radio :label="'click'">发送消息</el-radio>
                <el-radio :label="'view'">跳转网页</el-radio>
                <el-radio :label="'miniprogram'">跳转小程序</el-radio>
                <el-radio :label="'media_id'">图片</el-radio>
              </el-radio-group>
            </div>
            <!-- {{ num }} {{ linkinput }} -->

            <div v-if="radio === 'click'">
              <div class="right_sendmessage" style="height:300px">
                <div class="choosemessagewr">
                  <div style="font-size:14px;font-weight: 400;">选择要发送的消息：</div>
                  <div><el-tag v-if="imageobj.imagetextkey!=''" style="margin-right:10px">{{ imageobj.imagetexttitle }}</el-tag></div>
                  <div><el-button type="primary" size="mini" @click="choosecustomer">选择消息</el-button></div>
                </div>
                <div style="margin-left: 20px;color: red">*不支持点击菜单回复小程序消息</div>
                <!-- <div class="tab_navs_panel">
                  <div :class="num==='article_url'?'active_tab':''" style="cursor: pointer;" @click="imagetext">客服图文消息</div>
                  <div :class="num==='click'?'active_tab':''" style="margin-left:20px;cursor: pointer;" @click="customerservice">客服文字消息</div>
                  <div :class="num==='media_id'?'active_tab':''" style="margin-left:20px;cursor: pointer;" @click="imageclick">图片</div>

                </div> -->
                <!-- 图文消息 -->
                <!-- <div v-show="num==='article_url'">
                  <div class="allexamples_box">
                    <div class="examples_leftbox">
                      <div class="within_box">
                        <div>{{ imageobj.imagetexttitle }}</div>
                        <div class="imaetext se_top">
                          <div class="describe_text">{{ imageobj.imagetextdescribetion }}</div>
                          <div>
                            <img v-if="imageobj.imagetextsrc" style="width:50px;height:50px" :src="imageobj.imagetextsrc">
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="examples_rightbox">
                      <div class="input_box"><div>标题：</div><div><el-input v-model="imageobj.imagetexttitle" placeholder="请输入标题" @input="changetextimage(1)" /></div> </div>
                      <div class="input_box" style="display: inline;">
                        <div class="link_biwc">
                          <div>链接：</div>
                          <div><el-input v-model="imageobj.imagetexturl" style="width:500px" placeholder="请输入链接" @blur="handleInputBlur" @input="changetextimage(2)" /></div>
                        </div>
                        <div style="margin:18px 0px 0px 49px">
                          <el-select v-model="palateid" placeholder="请选择平台" @change="changepalate">
                            <el-option
                              v-for="items in plateoption"
                              :key="items.id"
                              :label="items.name"
                              :value="items.id"
                            />
                          </el-select>
                        </div>
                        <div style="margin:20px 0px 20px 38px">
                          <el-select v-model="addtifit" :disabled="palateid===''" filterable placeholder="添加标志" class="add_name">
                            <el-option
                              v-for="item in optionsr"
                              :key="item.key"
                              :label="item.value"
                              :value="item.key"
                            />
                          </el-select>
                          <el-link type="primary" @click="addidentifit">添加标志</el-link>
                        </div>

                      </div>
                      <div class="input_box"><div>描述：</div> <div><el-input v-model="imageobj.imagetextdescribetion" style="width:500px" type="textarea" placeholder="请输入描述" @input="changetextimage(3)" /></div></div>
                      <el-button type="primary" size="mini" @click="choosetextimageclcik">{{ imageobj.imagetextsrc === '' ? '选择封面' : '修改封面' }}</el-button>
                      <img v-if="imageobj.imagetextsrc" :src="imageobj.imagetextsrc" class="uopatatextimg">
                    </div>
                  </div>
                </div> -->
                <!-- 图片 -->
                <!-- <div v-show="num==='media_id'">
                  <div v-if="obg.img!== ''" class="updataimg">
                    <img :src="obg.img" class="img_updata">

                  </div>
                  <div class="chs_tab">
                    <el-button type="primary" size="mini" @click.stop="chooseiconclcik"> 素材库选择</el-button>
                    <el-button type="primary" size="mini" @click="$refs.file.click()">本地上传<input ref="file" style="display:none;" type="file" multiple accept="image/gif,image/jpg,image/jpeg,image/png" @change="uploadPictures"></el-button>
                  </div>
                </div> -->
                <!-- 客服消息 -->
                <!-- <div v-show="num==='click'" class="customer_box">
                  <el-input
                    v-model="obj.content"
                    type="textarea"
                    :rows="8"
                    placeholder="请输入内容"
                    @input="changetextareainput"
                    @blur="kefuInputBlur"
                  />
                  <div class="choose_textr">
                    <el-popover
                      placement="right"
                      width="400"
                      trigger="click"
                    >
                      <div style="display:flex;flex-wrap:wrap">
                        <div v-for="(item,index) in emoji_icon" :key="index" @click="itemclaickw(index)">
                          {{ item }}
                        </div>
                      </div>
                      <i slot="reference" class="el-icon-info" />
                    </el-popover>
                    <el-link type="primary" class="link_url" @click="linkdialogVisible = true">超链接</el-link>
                    <el-link type="primary" @click="keyworddialogVisible = true">关键词</el-link>

                  </div>
                  <div class="choose_plate">
                    <el-select v-model="textpalateid" class="add_name" placeholder="请选择平台" @change="changetextpalate">
                      <el-option
                        v-for="items in plateoption"
                        :key="items.id"
                        :label="items.name"
                        :value="items.id"
                      />
                    </el-select>
                  </div>
                  <el-select v-model="addname" :disabled="textpalateid===''" filterable placeholder="添加标志" class="add_name">
                    <el-option
                      v-for="item in options"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"
                    />
                  </el-select>
                  <el-link type="primary" @click="addnickname">添加标志</el-link>
                </div> -->
              </div>
            </div>
            <div v-if="radio === 'view'">
              <div class="link_box">
                <div class="title_ses">订阅者点击该子菜单会跳到以下链接</div>
                <div class="linew_boxr">
                  <div>页面地址</div>
                  <el-input v-model="linkinput" class="linkcalwe" style="width:500px" placeholder="地址" @blur="tiaoInputBlur" @input="linput" />
                </div>
                <div v-if="allpalateid == 99" class="linew_boxr">
                  <div style="margin-right:20px">选择链接所属平台</div>
                  <el-select v-model="urlpalateid" placeholder="请选择平台" @change="urlchange">
                    <el-option
                      v-for="items in plateoption"
                      :key="items.id"
                      :label="items.name"
                      :value="items.id"
                    />
                  </el-select>
                </div>
                <div style="margin-top:20px" @click="beforehandleCommand">
                  <el-dropdown trigger="click" @command="handleCommand">
                    <span class="el-dropdown-link">
                      添加链接活动<i class="el-icon-arrow-down el-icon--right" />
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-for="(item,index) in linkallarr" :key="index" :command="beforeHandleCommand(item.sign,item.identification)">{{ item.type_name }}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <!-- <div style="margin:10px 0px 0px 65px">
                  <el-select v-model="linkpalateid" class="add_name" placeholder="请选择平台" @change="changelinkpalate">
                    <el-option
                      v-for="items in plateoption"
                      :key="items.id"
                      :label="items.name"
                      :value="items.id"
                    />
                  </el-select>
                </div>
                <el-select v-model="webpageright" :disabled="linkpalateid === ''" filterable placeholder="添加标志" style="margin:15px 10px 0px 75px">
                  <el-option
                    v-for="item in linkoptions"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  />
                </el-select>
                <el-link type="primary" @click="addwebpage">添加标志</el-link> -->

              </div>
            </div>
            <div v-if="radio === 'miniprogram'">
              <!-- <div>暂未开通此功能</div> -->
              <div class="subscribeboxwr">
                <div class="sewrfw_box">订阅者点击该子菜单会跳到以下小程序</div>
                <div class="applet_box" style="display: block;">
                  <div>
                    小程序：
                  </div>
                  <el-radio-group v-model="wechatradio" style="margin-bottom: 20px;margin-top: 20px;" @change="weicharting">
                    <el-radio :label="1">指定小程序</el-radio>
                    <el-radio :label="2">小程序类型</el-radio>
                  </el-radio-group>
                  <div v-if="wechatradio == 1">
                    <el-input v-model="appid" style="width:300px;" placeholder="请输入appid" @input="linputtwo" />
                    <el-input v-model="pagepath" style="width:300px;margin-left: 20px;" placeholder="请输入路径" @input="linputone" />
                    <el-input v-model="url" style="width:300px;margin-left: 20px;" placeholder="请输入默认url路径" @input="urltwo" />
                  </div>
                  <div v-else>
                    <el-input v-if="appletsinput" v-model="appletsinput" disabled style="width:200px;margin-right:10px" />
                    <el-button @click="chooseapplets">选择小程序</el-button>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="radio === 'media_id'">
              <div class="subscribeboxwr">
                <div class="sewrfw_box">订阅者点击该子菜单会跳到以下图片</div>
                <div class="applet_box">
                  <div>
                    图片：
                  </div>
                  <el-button type="primary" size="mini" @click="choosetextimageclcikrrr">选择图片</el-button>
                </div>
                <el-image
                  v-if="imageid"
                  style="width: 100px; height: 100px;margin-top: 10px;"
                  :src="imagesrc"
                  fit="contain"
                />
                <!-- <img v-if="imageid" :src="imagesrc" alt="" style="width: 130px;height: 100px;margin-top: 10px;"> -->
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>

    <div class="save_box">
      <el-button v-if="this.$route.query.type === 0" size="mini" type="primary" @click="brn">保存</el-button>
      <el-button size="mini" type="primary" @click="gobackone">返回</el-button>
    </div>

    <!-- 上传图片弹窗 -->
    <el-dialog
      title="图片库"
      :visible.sync="dialogVisible"
      width="50%"
    >
      <chooseimg ref="mychild" @clickicon="clickicon" @kefuicon="kefuicon" @imgcallback="imgcallback" />
    </el-dialog>

    <!-- 选择客服消息模板弹窗 -->
    <el-dialog
      title="客服消息模板"
      :visible.sync="customerVisible"
      width="30%"
    >
      <customerservice ref="mychildtwo" @customecallback="customecallback" />
    </el-dialog>

    <!-- 超链接弹窗 -->
    <el-dialog title="超链接" :visible.sync="linkdialogVisible" append-to-body width="30%">
      <Linkdialog @linkbtn="linkbtn" />
    </el-dialog>
    <!-- 关键词弹窗 -->
    <el-dialog title="关键词" :visible.sync="keyworddialogVisible" append-to-body width="30%">
      <Keywordialog @keywordbtn="keywordbtn" />
    </el-dialog>
    <!-- 选择小程序弹窗 -->
    <el-dialog title="选择小程序" :visible.sync="appletsdialog" :destroy-on-close="true" append-to-body width="30%">
      <appletsdialog ref="appletsdialogview" @appletupdata="appletupdata" />
    </el-dialog>
    <!-- 选择客服消息 -->
    <el-dialog title="选择客服消息" :visible.sync="customerdialogview" :destroy-on-close="true" append-to-body width="55%">
      <customerdialog ref="customerdialogviewall" @kefucallback="kefucallback" />
    </el-dialog>
    <!-- 书城活动列表 -->
    <el-dialog title="选择活动" :visible.sync="bookctyactivitiesVisible" append-to-body width="40%">
      <bookctyactivities ref="bookctyactivitiesbox" @callbadwr="callbadwr" />
    </el-dialog>
    <!-- 发红包活动列表 -->
    <el-dialog title="选择红包" :visible.sync="redbao" append-to-body width="40%">
      <reddialog ref="chooseredbao" @redcallback="redcallback" />
    </el-dialog>
    <!-- 书城链接活动 -->
    <el-dialog title="选择书城链接" :visible.sync="sclink" append-to-body width="50%">
      <booklinkdialog ref="sclinkview" @sclinkcallback="sclinkcallback" />
    </el-dialog>
  </div>
</template>

<script>
// import chooseimg from './components/chooseimg.vue'
import chooseimg from './components/TencentCloudChooseimg.vue'
import customerservice from './components/customerservice.vue'
import { qiniuToken } from '@/api/qiniuToken.js'
import * as qiniu from 'qiniu-js'
import { listForOfficialTags } from '@/api/sourceMaterial.js'
import { getMaterialLibraryList, menuRichText, menuTemplate, menudetial, customerlogo, strategyPlatform, newMaterial, mptypeslist, getlinktypeslist } from '@/api/sourceMaterial.js'
import Linkdialog from './components/Linkdialog.vue'
import Keywordialog from './components/Keywordialog.vue'
import appletsdialog from './components/appletsdialog.vue'
import emojiicon from './js/expression.js'
import customerdialog from './components/customerdialog.vue'
import bookctyactivities from '../customerService/components/bookctyactivities.vue'
import reddialog from '../customerService/components/reddialog.vue'
import booklinkdialog from '../customerService/components/booklinkdialog.vue'
export default {
  components: {
    chooseimg,
    customerservice,
    Linkdialog,
    Keywordialog,
    appletsdialog,
    customerdialog,
    bookctyactivities,
    reddialog,
    booklinkdialog
  },
  data() {
    return {
      bookctyactivitiesVisible: false,
      redbao: false,
      sclink: false,
      customerdialogview: false,
      imageobj: {
        imagetexttitle: '',
        imagetextdescribetion: '',
        imagetextsrc: '',
        imagetexturl: '',
        imagetextkey: '',
        imageparid: ''
      },
      custobj: {
        customerids: null,
        customernames: null
      },
      menutemplateName: '', // 模板名称
      customerobj: {
        customerinput: '', // 客服消息模板
        customerid: ''// 客服消息选中的id
      },

      linkinput: '', // 跳转网页链接地址
      obg: {
        img: '',
        keys: ''
      },
      pageIfon: { // 获取素材库的参数
        type: 1,
        page: 1,
        pageSize: 10
      },
      num: 'article_url', // 选择 图文消息 图片 音频 视频 视频号动态 类型
      bg: null, // 控制 点击左侧菜单进行编辑操作这个div的显示与隐藏
      radio: '', // 选择内容的选项 click 发送消息 view 跳转网页 miniprogram 跳转小程序
      values: '', // input框绑定的值
      active: null, // 选中那一项id
      sonactive: null, // 子里面选中那一项id
      indexinput: null, // 取出来的索引值
      sonindexinput: null, // 子取出来的索引值
      selftype: null, // 判断点击是否为父菜单还是子菜单 parent son
      arr: [
        // {
        //   name: '菜单名称',
        //   id: Math.random(),
        //   arrs: [
        //     {
        //       name: 111,
        //       id: Math.random()
        //     }
        //   ]
        // },
        // {
        //   name: '菜单名称1',
        //   id: Math.random()
        // },
        // {
        //   name: '菜单名称3',
        //   id: Math.random()
        // }
      ],
      tags: [],
      dialogVisible: false, // 选择图片弹窗
      customerVisible: false, // 选择消息模板的弹窗
      imgarr: [/* {
        img: require('@/assets/larke/qinan.jpg'),
        key: 1
      }, {
        img: require('@/assets/larke/larke.png'),
        key: 2
      }*/],
      customerarr: [
        // {
        //   name: '模板1',
        //   id: 1
        // },
        // {
        //   name: '模板2',
        //   id: 2
        // }
      ],

      //  超链接弹窗
      linkdialogVisible: false,
      //  关键词弹窗
      keyworddialogVisible: false,
      // 表情数组
      emoji_icon: emojiicon.emoji_icon,
      // 文本域获取富文本绑定
      obj: {
        content: ''
      },
      options: [], // 客服消息数组
      addname: '', // 绑定客服消息绑定
      addtifit: '', //

      blurIndex: null, // 获取输入框索引值
      kefublurIndex: null,
      tiaoblurIndex: null,
      webpageright: null,

      palateid: '',
      optionsr: [],

      textpalateid: '',

      linkpalateid: '',
      linkoptions: [],

      token: null, // 七牛云token
      appletsinput: '',
      appletsid: '',
      appletsdialog: false,
      optionstype: [],
      plateoption: [],
      allpalateid: null,
      tagId: null,
      linkallarr: [],
      urlpalateid: '',
      tagslist: [],

      imagesrc: '',
      imageid: '',

      wechatradio: 1,
      pagepath: '',
      appid: '',
      url: ''
    }
  },
  created(e) {
    this.OfficialTagslist()
    this.getlist()
    this.handcustome()
    // this.getcustomercation()
    this.getstrategyplatform()
    // 获取七牛云
    this.getQiniuToken()
    this.getapplets()
    if (this.$route.query.deviceId) {
      this.getmenudetails(this.$route.query.deviceId)
    }
    console.log('tagId---', this.tagId)
  },
  mounted() {

  },
  methods: {
    random(min, max) {
      return Math.floor(Math.random() * (max - min)) + min
    },
    beforehandleCommand() {
      // eslint-disable-next-line eqeqeq
      if (this.allpalateid == 99 && this.urlpalateid == '') {
        this.linkallarr = []
        this.$message.error('选择链接所属平台')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.allpalateid != 99) {
        if (this.allpalateid === null) {
          this.$message.error('请选择平台')
          return
        }
      }
    },
    // 获取链接类型
    async getlinktypesalllist() {
      const data = await getlinktypeslist({
        platform_id: this.allpalateid
      })
      this.linkallarr = data.data
      console.log('data111', data)
    },
    // 获取链接类型2
    async getlinktypesalllisttwo() {
      const data = await getlinktypeslist({
        platform_id: this.urlpalateid
      })
      this.linkallarr = data.data
      console.log('data', data)
    },
    async getapplets() {
      const data = await mptypeslist()
      this.optionstype = data.data.types
      console.log('data', data)
    },
    // 获取七牛token
    async getQiniuToken() {
      const data = await qiniuToken()
      this.token = data.data.upToken
    },
    // 获取光标所在位置的index
    handleInputBlur(e) {
      this.blurIndex = e.srcElement.selectionStart
    },
    kefuInputBlur(e) {
      this.kefublurIndex = e.srcElement.selectionStart
    },
    tiaoInputBlur(e) {
      this.tiaoblurIndex = e.srcElement.selectionStart
    },
    // 获取策略平台
    async getstrategyplatform() {
      const data = await strategyPlatform()
      this.plateoption = data.data.list
      console.log('获取策略平台', data)
    },
    // // 获取客服消息标识
    async getcustomercationtwo() {
      const data = await customerlogo({
        platformId: this.textpalateid
      })
      this.options = data.data.list
      console.log('获取客服消息标识', data.data.list)
    },
    // 获取客服消息标识
    async getcustomercation() {
      const data = await customerlogo({
        platformId: this.palateid
      })
      this.optionsr = data.data.list
      console.log('获取客服消息标识', data.data.list)
    },
    async getcustomercationthree() {
      const data = await customerlogo({
        platformId: this.linkpalateid
      })
      this.linkoptions = data.data.list
      console.log('获取客服消息标识', data.data.list)
    },
    // 获取菜单详情详情
    getmenudetails(id) {
      menudetial({ id: id }).then(res => {
        this.indexinput = 0
        this.bg = -1
        // this.active = res.data.info.menuData[0].id
        // this.selftype = 'parent'
        // this.values = res.data.info.menuData[0].name
        this.menutemplateName = res.data.info.templateName
        this.allpalateid = res.data.info.platformId
        this.tagId = res.data.info.match_rule === null ? 0 : res.data.info.match_rule.tag_id
        for (let i = 0; i < res.data.info.menuData.length; i++) {
          res.data.info.menuData[i].showtips = false
        }
        this.arr = res.data.info.menuData
        this.getlinktypesalllist()
        console.log('获取菜单详情详情', res.data.info.menuData[0])
      })
    },
    // 获取素材库列表
    getlist() {
      getMaterialLibraryList(this.pageIfon).then(res => {
        console.log('res', res)
        this.imgarr = res.data
      })
    },
    async handcustome() {
      const data = await menuRichText({ name: '' })
      this.customerarr = data.data
    },
    // 获取标签组列表
    async OfficialTagslist() {
      const data = await listForOfficialTags()
      data.data.list.unshift({
        tag_group_name: '无（非个性化菜单）',
        id: 0
      })
      this.tagslist = data.data.list

      // this.total = data.data.total
      console.log('tagslist', data.data.list)
    },
    add(a, b, c) {
      return a + b + c
    },
    // 新增父菜单
    addmenu() {
      this.linkinput = '' // 清空链接 input
      this.urlpalateid = '' // 清空链接 urlpalateid
      this.appletsinput = ''
      this.appletsid = ''
      this.pagepath = ''
      this.appid = ''
      this.url = ''
      this.imagesrc = ''
      this.imageid = ''
      this.customerobj.customerinput = ''
      this.customerobj.customerid = ''
      this.obj.content = ''
      this.imageobj = {
        imagetexttitle: '',
        imagetextdescribetion: '',
        imagetextsrc: '',
        imagetexturl: '',
        imagetextkey: '',
        imageparid: ''
      }
      this.bg = null
      this.arr.forEach(item => {
        item.showtips = false
      })
      this.arr.push({
        name: '菜单名称',
        id: this.add(this.random(1000, 9999), Date.now(), this.random(1000, 9999)),
        showtips: true,
        sub_button: [],
        type: 'click',
        num: 'article_url',
        // custobj: {
        //   customerids: null,
        //   customernames: null
        // }
        cserviceobj: {
          title: '',
          url: '',
          description: '',
          platform_id: ''
          // customerids: '',
          // customernames: ''
        }
      })
      this.active = this.arr[this.arr.length - 1].id
      this.values = this.arr[this.arr.length - 1].name
      this.radio = this.arr[this.arr.length - 1].type
      this.num = this.arr[this.arr.length - 1].num
      this.indexinput = this.arr.length - 1
      this.selftype = 'parent'

      if (this.allpalateid != null) {
        this.getlinktypesalllist()
      }
      if (this.arr[this.indexinput].media_id) {
        // const indexs = this.imgarr.findIndex(item => {
        //   return item.id === this.arr[this.indexinput].media_id
        // })
        // if (indexs === -1) {
        //   console.log('不存在')
        // } else {
        //   this.obg.img = this.imgarr[indexs].path
        //   this.obg.keys = this.imgarr[indexs].id
        // }
        getMaterialLibraryList({
          page: 1,
          pageSize: 10,
          id: this.arr[this.indexinput].media_id
        }).then(res => {
          this.obg.img = res.data.list[0].path
          this.obg.keys = res.data.list[0].id
          // console.log('父菜单选中的图片', res.data.list[0])
        })
      } else {
        this.obg.img = ''
        this.obg.keys = ''
      }
    },
    // 点击父菜单
    choosemenu(item, index) {
      console.log('父', item)
      this.linkinput = '' // 清空链接 input
      this.urlpalateid = '' // 清空链接 input
      this.appletsinput = ''
      this.appletsid = ''
      this.pagepath = ''
      this.url = ''
      this.appid = ''
      this.imagesrc = ''
      this.imageid = ''
      this.customerobj.customerinput = ''
      this.customerobj.customerid = ''
      this.obj.content = ''
      this.imageobj = {
        imagetexttitle: '',
        imagetextdescribetion: '',
        imagetextsrc: '',
        imagetexturl: '',
        imagetextkey: '',
        imageparid: ''
      }
      this.bg = null
      this.sonactive = -1
      this.arr.forEach(item => {
        item.showtips = false
      })
      this.active = item.id
      this.indexinput = index
      this.selftype = 'parent'
      this.arr[index].showtips = true
      this.values = item.name
      this.num = item.num
      this.radio = item.type
      if (item.type === 'click') {
        // 点击子菜单显示图片 有图片 赋值显示 没有就显示赋值为空
        if (item.media_id) {
          // const indexs = this.imgarr.findIndex(items => {
          //   return items.id === item.media_id
          // })
          // if (index === -1) {
          //   console.log('不存在')
          // } else {
          //   this.obg.img = this.imgarr[indexs].path
          //   this.obg.keys = this.imgarr[indexs].id
          // }
          getMaterialLibraryList({
            page: 1,
            pageSize: 10,
            id: item.media_id
          }).then(res => {
            this.obg.img = res.data.list[0].path
            this.obg.keys = res.data.list[0].id
            // console.log('父菜单选中的图片', res.data.list[0])
          })
        } else {
          this.obg.img = ''
          this.obg.keys = ''
        }
        if (item.content) {
          console.log('有content')
          this.obj.content = item.content
          // console.log('有key')
          // const indexsre = this.customerarr.findIndex(itemsr => {
          //   return itemsr.id === item.key
          // })
          // if (index === -1) {
          //   console.log('不存在')
          // } else {
          //   this.customerobj.customerinput = this.customerarr[indexsre].name
          //   this.customerobj.customerid = this.customerarr[indexsre].id
          // }
        } else {
          console.log('无content')
        }
        if (item.cserviceobj) {
          console.log('有cserviceobj', item.cserviceobj)
          this.imageobj.imagetexttitle = item.cserviceobj.title
          this.imageobj.imagetexturl = item.cserviceobj.url
          this.imageobj.imagetextdescribetion = item.cserviceobj.description
          this.imageobj.imagetextsrc = item.cserviceobj.picurl
          this.imageobj.imagetextkey = item.cserviceobj.picurl
          this.imageobj.imageparid = item.cserviceobj.platform_id
        } else {
          console.log('无cserviceobj')
        }
      }
      if (item.type === 'view') {
        this.linkinput = ''
        this.urlpalateid = ''
        // this.arr[this.indexinput].sub_button[this.sonindexinput].url = this.linkinput
        if (this.arr[this.indexinput].url) {
          this.linkinput = this.arr[this.indexinput].url
        } else {
          this.arr[this.indexinput].url = ''
          this.linkinput = ''
        }

        if (this.arr[this.indexinput].platform_id) {
          this.urlpalateid = this.arr[this.indexinput].platform_id
        } else {
          this.arr[this.indexinput].platform_id = ''
          this.urlpalateid = ''
        }
        this.obg.img = ''
        this.obg.keys = ''
      }
      if (item.type === 'miniprogram') {
        console.log('miniprogram')
        this.appletsinput = ''
        this.appletsid = ''
        this.pagepath = ''
        this.appid = ''
        this.url = ''
        if (this.arr[this.indexinput].mini_program_type) {
          this.appletsid = this.arr[this.indexinput].mini_program_type
          // eslint-disable-next-line eqeqeq
          const index = this.optionstype.findIndex(item =>	item.mini_program_type == this.appletsid)
          // eslint-disable-next-line eqeqeq
          if (index != -1) {
            this.appletsinput = this.optionstype[index].type_name
          }
          if (Number(this.arr[this.indexinput].mini_program_type) === 1001) {
            this.wechatradio = 1
            this.pagepath = this.arr[this.indexinput].pagepath
            this.appid = this.arr[this.indexinput].appid
            this.url = this.arr[this.indexinput].url
          } else {
            this.wechatradio = 2
          }
        } else {
          this.arr[this.indexinput].mini_program_type = ''
          this.appletsinput = ''
          this.appletsid = ''
          this.pagepath = ''
          this.appid = ''
          this.url = ''
        }
      }
      if (item.type === 'media_id') {
        console.log('media_id')
        this.imagesrc = ''
        this.imageid = ''
        if (this.arr[this.indexinput].cimageid) {
          this.imageid = this.arr[this.indexinput].cimageid
          this.imagesrc = this.arr[this.indexinput].cimagesrc
        } else {
          this.arr[this.indexinput].cimageid = ''
          this.arr[this.indexinput].cimagesrc = ''
          this.imagesrc = ''
          this.imageid = ''
        }
      }
      // eslint-disable-next-line eqeqeq
      if (this.allpalateid != null && this.allpalateid == 99) {
        // this.getlinktypesalllist()
        // eslint-disable-next-line eqeqeq
        if (this.urlpalateid != '') {
          this.getlinktypesalllisttwo()
        }
      }
    },
    // 新增子菜单
    submenuaddclick(index) {
      this.linkinput = '' // 清空链接 input
      this.urlpalateid = '' // 清空链接 urlpalateid
      this.appletsinput = ''
      this.appletsid = ''
      this.pagepath = ''
      this.appid = ''
      this.url = ''
      this.imagesrc = ''
      this.imageid = ''
      this.customerobj.customerinput = ''
      this.customerobj.customerid = ''
      this.obj.content = ''
      this.imageobj = {
        imagetexttitle: '',
        imagetextdescribetion: '',
        imagetextsrc: '',
        imagetexturl: '',
        imagetextkey: '',
        imageparid: ''
      }
      this.bg = null
      this.active = -1
      this.indexinput = index
      this.arr[index].sub_button.push({
        name: '子菜单',
        id: this.add(this.random(1000, 9999), Date.now(), this.random(1000, 9999)),
        type: 'click',
        num: 'article_url',
        cserviceobj: {
          title: '',
          url: '',
          description: '',
          picurl: '',
          platform_id: ''
        }
      })
      this.sonactive = this.arr[index].sub_button[this.arr[index].sub_button.length - 1].id
      this.values = this.arr[index].sub_button[this.arr[index].sub_button.length - 1].name
      this.radio = this.arr[index].sub_button[this.arr[index].sub_button.length - 1].type
      this.num = this.arr[index].sub_button[this.arr[index].sub_button.length - 1].num
      this.sonindexinput = this.arr[index].sub_button.length - 1
      this.selftype = 'son'

      if (this.allpalateid != null) {
        this.getlinktypesalllist()
      }
      // 添加子菜单显示图片 有图片 赋值显示 没有就显示赋值为空
      if (this.arr[index].sub_button[this.arr[index].sub_button.length - 1].media_id) {
        // const indexs = this.imgarr.findIndex(item => {
        //   return item.id === this.arr[index].sub_button[this.arr[index].sub_button.length - 1].media_id
        // })
        // if (indexs === -1) {
        //   console.log('不存在')
        // } else {
        //   this.obg.img = this.imgarr[indexs].path
        //   this.obg.keys = this.imgarr[indexs].id
        // }
        getMaterialLibraryList({
          page: 1,
          pageSize: 10,
          id: this.arr[index].sub_button[this.arr[index].sub_button.length - 1].media_id
        }).then(res => {
          this.obg.img = res.data.list[0].path
          this.obg.keys = res.data.list[0].id
          // console.log('子菜单选中的图片', res.data.list[0])
        })
      } else {
        this.obg.img = ''
        this.obg.keys = ''
      }

      // 添加子菜单时 清空父菜单的值
      // this.arr[index].type = ''
      // this.arr[index].num = ''
      //  this.arr[index].media_id = ''
      delete this.arr[index].type
      delete this.arr[index].num
      delete this.arr[index].media_id
      delete this.arr[index].content
      delete this.arr[index].cserviceobj
      delete this.arr[index].mini_program_type
      delete this.arr[index].pagepath
      delete this.arr[index].url
      delete this.arr[index].appid
      delete this.arr[index].cimagesrc
      delete this.arr[index].cimageid
      delete this.arr[index].url
      delete this.arr[index].platform_id
    },
    // 点击子菜单
    sonmenuclick(item, index) {
      this.linkinput = '' // 清空链接 input
      this.urlpalateid = '' // 清空链接 input
      this.appletsinput = ''
      this.appletsid = ''
      this.pagepath = ''
      this.appid = ''
      this.url = ''
      this.imagesrc = ''
      this.imageid = ''
      this.customerobj.customerinput = ''
      this.customerobj.customerid = ''
      this.obj.content = ''
      this.imageobj = {
        imagetexttitle: '',
        imagetextdescribetion: '',
        imagetextsrc: '',
        imagetexturl: '',
        imagetextkey: '',
        imageparid: ''
      }
      this.bg = null
      this.active = -1
      this.sonactive = item.id
      this.sonindexinput = index
      this.selftype = 'son'
      this.values = item.name
      this.num = item.num
      this.radio = item.type

      if (item.type === 'click') {
        // 点击子菜单显示图片 有图片 赋值显示 没有就显示赋值为空
        if (item.media_id) {
          // const indexs = this.imgarr.findIndex(items => {
          //   return items.id === item.media_id
          // })
          // if (index === -1) {
          //   console.log('不存在')
          // } else {
          //   this.obg.img = this.imgarr[indexs].path
          //   this.obg.keys = this.imgarr[indexs].id
          //   console.log('indexs', indexs)
          // }
          getMaterialLibraryList({
            page: 1,
            pageSize: 10,
            id: item.media_id
          }).then(res => {
            this.obg.img = res.data.list[0].path
            this.obg.keys = res.data.list[0].id
          // console.log('子菜单选中的图片', res.data.list[0])
          })
        } else {
          this.obg.img = ''
          this.obg.keys = ''
        }
        if (item.content) {
          this.obj.content = item.content
          // console.log('有key')
          // const indexsr = this.customerarr.findIndex(items => {
          //   return items.id === item.key
          // })
          // if (index === -1) {
          //   console.log('不存在')
          // } else {
          //   this.customerobj.customerinput = this.customerarr[indexsr].name
          //   this.customerobj.customerid = this.customerarr[indexsr].id
          // }
        } else {
          console.log('无key')
        }
        if (item.cserviceobj) {
          console.log('有cserviceobj', item.cserviceobj)
          this.imageobj.imagetexttitle = item.cserviceobj.title
          this.imageobj.imagetexturl = item.cserviceobj.url
          this.imageobj.imagetextdescribetion = item.cserviceobj.description
          this.imageobj.imagetextsrc = item.cserviceobj.picurl
          this.imageobj.imagetextkey = item.cserviceobj.picurl
          this.imageobj.imageparid = item.cserviceobj.platform_id
        } else {
          console.log('无cserviceobj')
        }
      }
      if (item.type === 'view') {
        this.linkinput = ''
        this.urlpalateid = ''
        // this.arr[this.indexinput].sub_button[this.sonindexinput].url = this.linkinput
        if (this.arr[this.indexinput].sub_button[this.sonindexinput].url) {
          this.linkinput = this.arr[this.indexinput].sub_button[this.sonindexinput].url
        } else {
          this.arr[this.indexinput].sub_button[this.sonindexinput].url = ''
          this.linkinput = ''
        }

        if (this.arr[this.indexinput].sub_button[this.sonindexinput].platform_id) {
          this.urlpalateid = this.arr[this.indexinput].sub_button[this.sonindexinput].platform_id
        } else {
          this.arr[this.indexinput].sub_button[this.sonindexinput].platform_id = ''
          this.urlpalateid = ''
        }
        this.obg.img = ''
        this.obg.keys = ''
      }
      if (item.type === 'miniprogram') {
        console.log('miniprogram')
        this.appletsinput = ''
        this.appletsid = ''
        this.pagepath = ''
        this.appid = ''
        this.url = ''
        if (this.arr[this.indexinput].sub_button[this.sonindexinput].mini_program_type) {
          this.appletsid = this.arr[this.indexinput].sub_button[this.sonindexinput].mini_program_type
          // eslint-disable-next-line eqeqeq
          const index = this.optionstype.findIndex(item =>	item.mini_program_type == this.appletsid)
          // eslint-disable-next-line eqeqeq
          if (index != -1) {
            this.appletsinput = this.optionstype[index].type_name
          }
          if (this.arr[this.indexinput].sub_button[this.sonindexinput].mini_program_type === 1001) {
            this.wechatradio = 1
            this.pagepath = this.arr[this.indexinput].sub_button[this.sonindexinput].pagepath
            this.appid = this.arr[this.indexinput].sub_button[this.sonindexinput].appid
            this.url = this.arr[this.indexinput].sub_button[this.sonindexinput].url
          } else {
            this.wechatradio = 2
          }
        } else {
          this.arr[this.indexinput].sub_button[this.sonindexinput].mini_program_type = ''
          this.appletsinput = ''
          this.appletsid = ''
          this.pagepath = ''
          this.appid = ''
          this.url = ''
        }
      }

      if (item.type === 'media_id') {
        console.log('media_id')
        this.imagesrc = ''
        this.imageid = ''
        if (this.arr[this.indexinput].sub_button[this.sonindexinput].cimageid) {
          this.imageid = this.arr[this.indexinput].sub_button[this.sonindexinput].cimageid
          this.imagesrc = this.arr[this.indexinput].sub_button[this.sonindexinput].cimagesrc
        } else {
          this.arr[this.indexinput].sub_button[this.sonindexinput].cimageid = ''
          this.arr[this.indexinput].sub_button[this.sonindexinput].cimagesrc = ''
          this.imagesrc = ''
          this.imageid = ''
        }
      }
      // eslint-disable-next-line eqeqeq
      if (this.allpalateid != null && this.allpalateid == 99) {
        // this.getlinktypesalllist()
        // eslint-disable-next-line eqeqeq
        if (this.urlpalateid != '') {
          this.getlinktypesalllisttwo()
        }
      }
    },
    changeinput(val) {
      if (this.selftype === 'parent') {
        this.arr[this.indexinput].name = val
      } else {
        this.arr[this.indexinput].sub_button[this.sonindexinput].name = val
      }

      console.log(val)
    },
    changetextareainput(val) {
      console.log('val', val)
      if (this.selftype === 'parent') {
        this.arr[this.indexinput].content = val
      } else {
        this.arr[this.indexinput].sub_button[this.sonindexinput].content = val
      }
    },
    // 删除菜单
    deletmenu() {
      if (this.selftype === 'parent') {
        this.arr.splice(this.indexinput, 1)
        this.bg = -1
      } else {
        this.arr[this.indexinput].sub_button.splice(this.sonindexinput, 1)

        // 子数组的东西被删除为0
        if (this.arr[this.indexinput].sub_button.length === 0) {
          // 数组更改
          this.arr[this.indexinput].num = 'article_url'
          this.arr[this.indexinput].type = 'click'

          this.arr[this.indexinput].cserviceobj = {
            title: '',
            url: '',
            description: '',
            picurl: '',
            platform_id: ''
          }
          // 视图更改
          this.num = 'article_url'
          this.radio = 'click'
        }
        this.bg = -1
      }
    },
    // 当radio改变时回调
    changeradio(val) {
      console.log('val', this.radio)
      if (this.selftype === 'parent') {
        this.arr[this.indexinput].type = val
        if (val === 'click') {
          // 当点击click 时 有两种情况 一种 就是 图文 还有图片
          // console.log('this.arr[this.indexinput].sub_button[this.sonindexinput]', this.arr[this.indexinput].sub_button[this.sonindexinput].num)
          if (this.arr[this.indexinput].num === 'article_url') {
            this.arr[this.indexinput].cserviceobj = {}
            this.arr[this.indexinput].cserviceobj.title = this.imageobj.imagetexttitle
            this.arr[this.indexinput].cserviceobj.url = this.imageobj.imagetexturl
            this.arr[this.indexinput].cserviceobj.description = this.imageobj.imagetextdescribetion
            this.arr[this.indexinput].cserviceobj.picurl = this.imageobj.imagetextsrc
            this.arr[this.indexinput].cserviceobj.platform_id = this.imageobj.imageparid
            delete this.arr[this.indexinput].media_id
            delete this.arr[this.indexinput].content
          }
          if (this.arr[this.indexinput].num === 'media_id') {
            delete this.arr[this.indexinput].content
            delete this.arr[this.indexinput].cserviceobj
            this.arr[this.indexinput].media_id = this.obg.keys
          }
          if (this.arr[this.indexinput].num === 'click') {
            delete this.arr[this.indexinput].media_id
            delete this.arr[this.indexinput].cserviceobj
            this.arr[this.indexinput].content = this.obj.content
          }
          console.log('222')
          // 删除 view 情况下 url 字段
          delete this.arr[this.indexinput].url
          delete this.arr[this.indexinput].platform_id
          delete this.arr[this.indexinput].mini_program_type
        }
        if (val === 'view') {
          // this.arr[this.indexinput].sub_button[this.sonindexinput].media_id = ''
          delete this.arr[this.indexinput].media_id
          delete this.arr[this.indexinput].content
          delete this.arr[this.indexinput].cserviceobj
          delete this.arr[this.indexinput].mini_program_type
          // 添加 url字段
          this.arr[this.indexinput].url = this.linkinput
          this.arr[this.indexinput].platform_id = this.urlpalateid
        }
        if (val === 'miniprogram') {
          delete this.arr[this.indexinput].media_id
          delete this.arr[this.indexinput].content
          delete this.arr[this.indexinput].cserviceobj

          delete this.arr[this.indexinput].url
          delete this.arr[this.indexinput].platform_id

          // eslint-disable-next-line eqeqeq
          if (this.wechatradio == 1) {
            this.arr[this.indexinput].mini_program_type = 1001
            this.arr[this.indexinput].pagepath = this.pagepath
            this.arr[this.indexinput].appid = this.appid
            this.arr[this.indexinput].url = this.url
          } else {
            this.arr[this.indexinput].mini_program_type = this.appletsid
            this.arr[this.indexinput].pagepath = ''
            this.arr[this.indexinput].appid = ''
            this.arr[this.indexinput].url = ''
          }

          // const index = this.optionstype.findIndex(item =>	item.mini_program_type == this.appletsid)
          // this.appletsinput = this.optionstype[index].type_name
        }
        if (val === 'media_id') {
          delete this.arr[this.indexinput].media_id
          delete this.arr[this.indexinput].content
          delete this.arr[this.indexinput].cserviceobj

          delete this.arr[this.indexinput].url
          delete this.arr[this.indexinput].platform_id

          this.arr[this.indexinput].cimagesrc = this.imagesrc
          this.arr[this.indexinput].cimageid = this.imageid
          // const index = this.optionstype.findIndex(item =>	item.mini_program_type == this.appletsid)
          // this.appletsinput = this.optionstype[index].type_name
        }
      } else {
        // 我是子菜单的情况
        this.arr[this.indexinput].sub_button[this.sonindexinput].type = val

        if (val === 'click') {
          // 当点击click 时 有两种情况 一种 就是 图文 还有图片

          if (this.arr[this.indexinput].sub_button[this.sonindexinput].num === 'article_url') {
            this.arr[this.indexinput].sub_button[this.sonindexinput].cserviceobj = {}
            this.arr[this.indexinput].sub_button[this.sonindexinput].cserviceobj.title = this.imageobj.imagetexttitle
            this.arr[this.indexinput].sub_button[this.sonindexinput].cserviceobj.url = this.imageobj.imagetexturl
            this.arr[this.indexinput].sub_button[this.sonindexinput].cserviceobj.description = this.imageobj.imagetextdescribetion
            this.arr[this.indexinput].sub_button[this.sonindexinput].cserviceobj.picurl = this.imageobj.imagetextkey
            this.arr[this.indexinput].sub_button[this.sonindexinput].cserviceobj.platform_id = this.imageobj.imageparid
            delete this.arr[this.indexinput].sub_button[this.sonindexinput].media_id
            delete this.arr[this.indexinput].sub_button[this.sonindexinput].content
          }
          if (this.arr[this.indexinput].sub_button[this.sonindexinput].num === 'media_id') {
            delete this.arr[this.indexinput].sub_button[this.sonindexinput].content
            delete this.arr[this.indexinput].sub_button[this.sonindexinput].cserviceobj
            this.arr[this.indexinput].sub_button[this.sonindexinput].media_id = this.obg.keys
          }
          if (this.arr[this.indexinput].sub_button[this.sonindexinput].num === 'click') {
            delete this.arr[this.indexinput].sub_button[this.sonindexinput].media_id
            delete this.arr[this.indexinput].sub_button[this.sonindexinput].cserviceobj
            this.arr[this.indexinput].sub_button[this.sonindexinput].content = this.obj.content
          }
          // 删除 view 情况下 url 字段
          delete this.arr[this.indexinput].sub_button[this.sonindexinput].url
          delete this.arr[this.indexinput].sub_button[this.sonindexinput].platform_id

          delete this.arr[this.indexinput].sub_button[this.sonindexinput].mini_program_type
          delete this.arr[this.indexinput].sub_button[this.sonindexinput].pagepath
          delete this.arr[this.indexinput].sub_button[this.sonindexinput].appid
          delete this.arr[this.indexinput].sub_button[this.sonindexinput].url
        }
        if (val === 'view') {
          delete this.arr[this.indexinput].sub_button[this.sonindexinput].content
          delete this.arr[this.indexinput].sub_button[this.sonindexinput].key
          delete this.arr[this.indexinput].sub_button[this.sonindexinput].cserviceobj

          delete this.arr[this.indexinput].sub_button[this.sonindexinput].mini_program_type
          delete this.arr[this.indexinput].sub_button[this.sonindexinput].pagepath
          delete this.arr[this.indexinput].sub_button[this.sonindexinput].appid
          delete this.arr[this.indexinput].sub_button[this.sonindexinput].url
          // 添加 url字段
          this.arr[this.indexinput].sub_button[this.sonindexinput].url = this.linkinput
          this.arr[this.indexinput].sub_button[this.sonindexinput].platform_id = this.urlpalateid
        }
        if (val === 'miniprogram') {
          delete this.arr[this.indexinput].sub_button[this.sonindexinput].media_id
          delete this.arr[this.indexinput].sub_button[this.sonindexinput].content
          delete this.arr[this.indexinput].sub_button[this.sonindexinput].cserviceobj

          delete this.arr[this.indexinput].sub_button[this.sonindexinput].url
          delete this.arr[this.indexinput].sub_button[this.sonindexinput].platform_id

          // eslint-disable-next-line eqeqeq
          if (this.wechatradio == 1) {
            this.arr[this.indexinput].sub_button[this.sonindexinput].mini_program_type = 1001
            this.arr[this.indexinput].sub_button[this.sonindexinput].pagepath = this.pagepath
            this.arr[this.indexinput].sub_button[this.sonindexinput].appid = this.appid
            this.arr[this.indexinput].sub_button[this.sonindexinput].url = this.url
          } else {
            this.arr[this.indexinput].sub_button[this.sonindexinput].mini_program_type = this.appletsid
            this.arr[this.indexinput].sub_button[this.sonindexinput].pagepath = ''
            this.arr[this.indexinput].sub_button[this.sonindexinput].appid = ''
            this.arr[this.indexinput].sub_button[this.sonindexinput].url = ''
          }
        }
        if (val === 'media_id') {
          delete this.arr[this.indexinput].sub_button[this.sonindexinput].media_id
          delete this.arr[this.indexinput].sub_button[this.sonindexinput].content
          delete this.arr[this.indexinput].sub_button[this.sonindexinput].cserviceobj

          delete this.arr[this.indexinput].sub_button[this.sonindexinput].url
          delete this.arr[this.indexinput].sub_button[this.sonindexinput].platform_id

          this.arr[this.indexinput].sub_button[this.sonindexinput].cimagesrc = this.imagesrc
          this.arr[this.indexinput].sub_button[this.sonindexinput].cimageid = this.imageid
        }
      }
    },
    async brn() {
      console.log('arr', this.arr)
      console.log('tagId---', this.tagId)
      const datas = await menuTemplate({ templateName: this.menutemplateName, menuData: this.arr, platformId: this.allpalateid, tagGroupId: this.tagId })
      if (datas.code === 200) {
        this.$message({
          message: '保存成功',
          type: 'success'
        })
        // this.$router.push({ path: '/officialAccountManagement/menutemplateList/index' })
        this.$router.push({ path: '/accountlisrt/index/menutemplateList/index' })
      }
      console.log(datas)
    },

    // 选择图片弹窗
    chooseiconclcik() {
      this.dialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.mychild.parentHandleclick('1')
      }, 100)
    },
    // 选择图片回调
    clickicon(img, key) {
      this.dialogVisible = false
      console.log('纯图片回调', img, key)
      // 显示图片赋值
      this.obg.img = img
      this.obg.keys = key

      if (this.selftype === 'parent') {
        this.arr[this.indexinput].media_id = key
      } else {
        this.arr[this.indexinput].sub_button[this.sonindexinput].media_id = key
      }
    },
    // 选择图片弹窗
    choosetextimageclcik() {
      this.dialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.mychild.parentHandleclick('2')
      }, 100)
    },
    // 选择图片弹窗
    choosetextimageclcikrrr() {
      this.dialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.mychild.parentHandleclick('3')
      }, 100)
    },
    kefuicon(imgs, keys) {
      this.dialogVisible = false
      // 显示图片赋值
      this.imageobj.imagetextsrc = imgs
      this.imageobj.imagetextkey = keys
      if (this.selftype === 'parent') {
        this.arr[this.indexinput].cserviceobj.picurl = imgs
      } else {
        this.arr[this.indexinput].sub_button[this.sonindexinput].cserviceobj.picurl = imgs
      }
    },
    imgcallback(imgs, keys) {
      this.dialogVisible = false
      // 显示图片赋值
      // this.imageobj.imagetextsrc = imgs
      // this.imageobj.imagetextkey = keys
      // if (this.selftype === 'parent') {
      //   this.arr[this.indexinput].cserviceobj.picurl = imgs
      // } else {
      //   this.arr[this.indexinput].sub_button[this.sonindexinput].cserviceobj.picurl = imgs
      // }
      this.imagesrc = imgs
      this.imageid = keys
      if (this.selftype === 'parent') {
        this.arr[this.indexinput].cimagesrc = imgs
        this.arr[this.indexinput].cimageid = keys
      } else {
        this.arr[this.indexinput].sub_button[this.sonindexinput].cimagesrc = imgs
        this.arr[this.indexinput].sub_button[this.sonindexinput].cimageid = keys
      }
    },
    // 点击图文消息
    imagetext() {
      this.num = 'article_url'
      if (this.selftype === 'parent') {
        this.arr[this.indexinput].cserviceobj = {}
        this.arr[this.indexinput].num = 'article_url'
        this.arr[this.indexinput].cserviceobj.title = this.imageobj.imagetexttitle
        this.arr[this.indexinput].cserviceobj.url = this.imageobj.imagetexturl
        this.arr[this.indexinput].cserviceobj.description = this.imageobj.imagetextdescribetion
        this.arr[this.indexinput].cserviceobj.picurl = this.imageobj.imagetextsrc
        this.arr[this.indexinput].cserviceobj.platform_id = this.imageobj.imageparid
        // 删除客服消息的key
        delete this.arr[this.indexinput].content
        // 删除客服消息的图片media_id
        delete this.arr[this.indexinput].media_id
      } else {
        this.arr[this.indexinput].sub_button[this.sonindexinput].cserviceobj = {}
        this.arr[this.indexinput].sub_button[this.sonindexinput].num = 'article_url'
        this.arr[this.indexinput].sub_button[this.sonindexinput].cserviceobj.title = this.imageobj.imagetexttitle
        this.arr[this.indexinput].sub_button[this.sonindexinput].cserviceobj.url = this.imageobj.imagetexturl
        this.arr[this.indexinput].sub_button[this.sonindexinput].cserviceobj.description = this.imageobj.imagetextdescribetion
        this.arr[this.indexinput].sub_button[this.sonindexinput].cserviceobj.picurl = this.imageobj.imagetextsrc
        this.arr[this.indexinput].sub_button[this.sonindexinput].cserviceobj.platform_id = this.imageobj.imageparid
        // 删除客服消息的图片media_id
        delete this.arr[this.indexinput].sub_button[this.sonindexinput].media_id
        // 删除客服消息的key
        delete this.arr[this.indexinput].sub_button[this.sonindexinput].content
      }
    },
    // 点击图片
    imageclick() {
      this.num = 'media_id'
      if (this.selftype === 'parent') {
        this.arr[this.indexinput].num = 'media_id'
        // 点击图片 在切换回来把值赋值回去
        this.arr[this.indexinput].media_id = this.obg.keys
        // 删除客服消息的key
        delete this.arr[this.indexinput].content

        delete this.arr[this.indexinput].cserviceobj
      } else {
        this.arr[this.indexinput].sub_button[this.sonindexinput].num = 'media_id'
        // 点击图片 在切换回来把值赋值回去
        this.arr[this.indexinput].sub_button[this.sonindexinput].media_id = this.obg.keys

        // 删除客服消息的key
        delete this.arr[this.indexinput].sub_button[this.sonindexinput].content

        delete this.arr[this.indexinput].sub_button[this.sonindexinput].cserviceobj
      }
    },
    // 点击客服消息
    customerservice() {
      this.num = 'click'
      if (this.selftype === 'parent') {
        this.arr[this.indexinput].num = 'click'
        // 点击客服消息 在切换回来把值赋值回去
        this.arr[this.indexinput].content = this.obj.content
        // this.arr[this.indexinput].key = this.customerobj.customerid
        this.arr[this.indexinput]
        // 删除客服消息的图片media_id
        delete this.arr[this.indexinput].media_id

        delete this.arr[this.indexinput].cserviceobj
      } else {
        this.arr[this.indexinput].sub_button[this.sonindexinput].num = 'click'
        // 点击客服消息 在切换回来把值赋值回去
        this.arr[this.indexinput].sub_button[this.sonindexinput].content = this.obj.content
        // 删除客服消息的图片media_id
        delete this.arr[this.indexinput].sub_button[this.sonindexinput].media_id

        delete this.arr[this.indexinput].sub_button[this.sonindexinput].cserviceobj
      }
    },
    // 点击客服消息 选择模板
    customerclick() {
      // console.log('客服')
      this.customerVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.mychildtwo.customeoncallback()
      }, 100)
    },
    // 选择客服消息 回调
    customecallback(customename, customeids) {
      this.customerVisible = false
      if (this.selftype === 'parent') {
        this.arr[this.indexinput].key = customeids
        this.customerobj.customerinput = customename
        this.customerobj.customerid = customeids
      } else {
        this.arr[this.indexinput].sub_button[this.sonindexinput].key = customeids
        this.customerobj.customerinput = customename
        this.customerobj.customerid = customeids
      }
    },
    // 输入链接回调事件
    linput(val) {
      if (this.selftype === 'parent') {
        this.arr[this.indexinput].url = val
      } else {
        this.arr[this.indexinput].sub_button[this.sonindexinput].url = val
      }
    },
    // 输入链接回调事件
    linputone(val) {
      if (this.selftype === 'parent') {
        this.arr[this.indexinput].pagepath = val
      } else {
        this.arr[this.indexinput].sub_button[this.sonindexinput].pagepath = val
      }
    },
    // 输入链接回调事件
    linputtwo(val) {
      if (this.selftype === 'parent') {
        this.arr[this.indexinput].appid = val
      } else {
        this.arr[this.indexinput].sub_button[this.sonindexinput].appid = val
      }
    },
    // 输入链接回调事件
    urltwo(val) {
      if (this.selftype === 'parent') {
        this.arr[this.indexinput].url = val
      } else {
        this.arr[this.indexinput].sub_button[this.sonindexinput].url = val
      }
    },
    urlchange(val) {
      this.getlinktypesalllisttwo()
      if (this.selftype === 'parent') {
        this.arr[this.indexinput].platform_id = val
        this.arr[this.indexinput].url = ''
        this.linkinput = ''
      } else {
        this.arr[this.indexinput].sub_button[this.sonindexinput].platform_id = val
        this.arr[this.indexinput].sub_button[this.sonindexinput].url = ''
        this.linkinput = ''
      }
    },
    // 点击表情回调
    itemclaickw(idx) {
      // this.obj.content += this.emoji_icon[idx]

      // if (this.selftype === 'parent') {
      //   this.arr[this.indexinput].content += this.emoji_icon[idx]
      // } else {
      //   this.arr[this.indexinput].sub_button[this.sonindexinput].content += this.emoji_icon[idx]
      // }

      this.obj.content = this.obj.content.slice(0, this.kefublurIndex) + this.emoji_icon[idx] + this.obj.content.slice(this.kefublurIndex)
      if (this.selftype === 'parent') {
        this.arr[this.indexinput].content = this.arr[this.indexinput].content.slice(0, this.kefublurIndex) + this.emoji_icon[idx] + this.arr[this.indexinput].content.slice(this.kefublurIndex)
      } else {
        this.arr[this.indexinput].sub_button[this.sonindexinput].content = this.arr[this.indexinput].sub_button[this.sonindexinput].content.slice(0, this.kefublurIndex) + this.emoji_icon[idx] + this.arr[this.indexinput].sub_button[this.sonindexinput].content.slice(this.kefublurIndex)
        // this.arr[this.indexinput].sub_button[this.sonindexinput].content += this.emoji_icon[idx]
      }
    },
    // 选择超链接回调
    linkbtn(linkobj) {
      // this.obj.content += `<a href="${linkobj.linkwritten}">${linkobj.written}</a>`
      // this.linkdialogVisible = false
      // if (this.selftype === 'parent') {
      //   this.arr[this.indexinput].content += `<a href="${linkobj.linkwritten}">${linkobj.written}</a>`
      // } else {
      //   this.arr[this.indexinput].sub_button[this.sonindexinput].content += `<a href="${linkobj.linkwritten}">${linkobj.written}</a>`
      // }
      this.obj.content = this.obj.content.slice(0, this.kefublurIndex) + `<a href="${linkobj.linkwritten}">${linkobj.written}</a>` + this.obj.content.slice(this.kefublurIndex)
      this.linkdialogVisible = false
      if (this.selftype === 'parent') {
        this.arr[this.indexinput].content = this.arr[this.indexinput].content.slice(0, this.kefublurIndex) + `<a href="${linkobj.linkwritten}">${linkobj.written}</a>` + this.arr[this.indexinput].content.slice(this.kefublurIndex)
      } else {
        this.arr[this.indexinput].sub_button[this.sonindexinput].content = this.arr[this.indexinput].sub_button[this.sonindexinput].content.slice(0, this.kefublurIndex) + `<a href="${linkobj.linkwritten}">${linkobj.written}</a>` + this.arr[this.indexinput].sub_button[this.sonindexinput].content.slice(this.kefublurIndex)
      }
    },
    // 选择关键词回调
    keywordbtn(keywordobj) {
      // this.obj.content += `<a href="weixin://bizmsgmenu?msgmenuid=1&msgmenucontent=${keywordobj.keywordwritten}">${keywordobj.keywordtext}</a>`
      // this.keyworddialogVisible = false
      // if (this.selftype === 'parent') {
      //   this.arr[this.indexinput].content += `<a href="weixin://bizmsgmenu?msgmenuid=1&msgmenucontent=${keywordobj.keywordwritten}">${keywordobj.keywordtext}</a>`
      // } else {
      //   this.arr[this.indexinput].sub_button[this.sonindexinput].content += `<a href="weixin://bizmsgmenu?msgmenuid=1&msgmenucontent=${keywordobj.keywordwritten}">${keywordobj.keywordtext}</a>`
      // }

      this.obj.content = this.obj.content.slice(0, this.kefublurIndex) + `<a href="weixin://bizmsgmenu?msgmenuid=1&msgmenucontent=${keywordobj.keywordwritten}">${keywordobj.keywordtext}</a>` + this.obj.content.slice(this.kefublurIndex)
      this.keyworddialogVisible = false
      if (this.selftype === 'parent') {
        this.arr[this.indexinput].content = this.arr[this.indexinput].content.slice(0, this.kefublurIndex) + `<a href="weixin://bizmsgmenu?msgmenuid=1&msgmenucontent=${keywordobj.keywordwritten}">${keywordobj.keywordtext}</a>` + this.arr[this.indexinput].content.slice(this.kefublurIndex)
      } else {
        this.arr[this.indexinput].sub_button[this.sonindexinput].content = this.arr[this.indexinput].sub_button[this.sonindexinput].content.slice(0, this.kefublurIndex) + `<a href="weixin://bizmsgmenu?msgmenuid=1&msgmenucontent=${keywordobj.keywordwritten}">${keywordobj.keywordtext}</a>` + this.arr[this.indexinput].sub_button[this.sonindexinput].content.slice(this.kefublurIndex)
      }
    },

    addnickname() {
      console.log('addname', this.addname)
      if (this.addname === '') {
        this.$message.error('请选择昵称')
        return
      }
      // this.obj.content += this.addname
      // if (this.selftype === 'parent') {
      //   this.arr[this.indexinput].content += this.addname
      // } else {
      //   this.arr[this.indexinput].sub_button[this.sonindexinput].content += this.addname
      // }

      this.obj.content = this.obj.content.slice(0, this.kefublurIndex) + this.addname + this.obj.content.slice(this.kefublurIndex)
      if (this.selftype === 'parent') {
        this.arr[this.indexinput].content = this.arr[this.indexinput].content.slice(0, this.kefublurIndex) + this.addname + this.arr[this.indexinput].content.slice(this.kefublurIndex)
      } else {
        this.arr[this.indexinput].sub_button[this.sonindexinput].content = this.arr[this.indexinput].sub_button[this.sonindexinput].content.slice(0, this.kefublurIndex) + this.addname + this.arr[this.indexinput].sub_button[this.sonindexinput].content.slice(this.kefublurIndex)
      }
    },
    addidentifit() {
      if (this.addtifit === '') {
        this.$message.error('请选择标志')
      }
      this.imageobj.imagetexturl = this.imageobj.imagetexturl.slice(0, this.blurIndex) + this.addtifit + this.imageobj.imagetexturl.slice(this.blurIndex)

      // this.imageobj.imagetexturl += this.addtifit
      // this.arr[this.indexinput].cserviceobj.url += this.addtifit

      // this.arr[this.indexinput].cserviceobj.url = this.arr[this.indexinput].cserviceobj.url.slice(0, this.blurIndex) + this.addtifit + this.arr[this.indexinput].cserviceobj.url.slice(this.blurIndex)

      if (this.selftype === 'parent') {
        this.arr[this.indexinput].cserviceobj.url = this.arr[this.indexinput].cserviceobj.url.slice(0, this.blurIndex) + this.addtifit + this.arr[this.indexinput].cserviceobj.url.slice(this.blurIndex)
      } else {
        // this.arr[this.indexinput].sub_button[this.sonindexinput].cserviceobj.url = this.imageobj.imagetexturl
        this.arr[this.indexinput].sub_button[this.sonindexinput].cserviceobj.url = this.arr[this.indexinput].sub_button[this.sonindexinput].cserviceobj.url.slice(0, this.blurIndex) + this.addtifit + this.arr[this.indexinput].sub_button[this.sonindexinput].cserviceobj.url.slice(this.blurIndex)
      }
    },
    // 图文输入标题回调
    changetextimage(typenums) {
      if (this.selftype === 'parent') {
        // this.arr[this.indexinput].url = val
        if (typenums === 1) {
          this.arr[this.indexinput].cserviceobj.title = this.imageobj.imagetexttitle
          console.log('标题：', this.imageobj.imagetexttitle)
        } else if (typenums === 2) {
          this.arr[this.indexinput].cserviceobj.url = this.imageobj.imagetexturl
          console.log('链接：', this.imageobj.imagetexturl)
        } else {
          this.arr[this.indexinput].cserviceobj.description = this.imageobj.imagetextdescribetion
          console.log('描述：', this.imageobj.imagetextdescribetion)
        }
      } else {
        // this.arr[this.indexinput].sub_button[this.sonindexinput].url = val
        if (typenums === 1) {
          this.arr[this.indexinput].sub_button[this.sonindexinput].cserviceobj.title = this.imageobj.imagetexttitle
          console.log('标题子：', this.imageobj.imagetexttitle)
        } else if (typenums === 2) {
          this.arr[this.indexinput].sub_button[this.sonindexinput].cserviceobj.url = this.imageobj.imagetexturl
          console.log('链接子：', this.imageobj.imagetexturl)
        } else {
          this.arr[this.indexinput].sub_button[this.sonindexinput].cserviceobj.description = this.imageobj.imagetextdescribetion
          console.log('描述子：', this.imageobj.imagetextdescribetion)
        }
      }
    },

    gobackone() {
      // this.$router.go(-1)
      this.$router.push({ path: '/accountlisrt/index/menutemplateList/index' })
    },
    addwebpage() {
      if (this.webpageright === null) {
        this.$message.error('请选择标志')
        return
      }
      this.linkinput = this.linkinput.slice(0, this.tiaoblurIndex) + this.webpageright + this.linkinput.slice(this.tiaoblurIndex)
      if (this.selftype === 'parent') {
        // this.arr[this.indexinput].url = val
        this.arr[this.indexinput].url = this.arr[this.indexinput].url.slice(0, this.tiaoblurIndex) + this.webpageright + this.arr[this.indexinput].url.slice(this.tiaoblurIndex)
      } else {
        // this.arr[this.indexinput].sub_button[this.sonindexinput].url = val
        this.arr[this.indexinput].sub_button[this.sonindexinput].url = this.arr[this.indexinput].sub_button[this.sonindexinput].url.slice(0, this.tiaoblurIndex) + this.webpageright + this.arr[this.indexinput].sub_button[this.sonindexinput].url.slice(this.tiaoblurIndex)
      }
    },

    changepalate(val) {
      console.log('val', val)
      this.arr.forEach((item, index) => {
        if (item.type === 'view') {
          // eslint-disable-next-line eqeqeq
          if (item.sub_button.length == 0) {
            item.platform_id = ''
            item.url = ''
          }
        }
      })
      this.arr.forEach((item, index) => {
        item.sub_button.forEach((items, index) => {
          if (item.type === 'view') {
            items.platform_id = ''
            items.url = ''
          }
        })
      })
      this.linkinput = ''
      this.urlpalateid = ''
      this.linkallarr = []
      this.getlinktypesalllist()
      // eslint-disable-next-line eqeqeq
      // if (val == 99) {
      //   this.linkallarr = []
      //   // eslint-disable-next-line eqeqeq
      //   if (this.urlpalateid != '') {
      //     this.getlinktypesalllisttwo()
      //   }
      // } else {
      //   this.getlinktypesalllist()
      // }

      // this.optionsr = []
      // this.addtifit = ''
      // this.getcustomercation()
    },
    // 标签改变
    changeTags(val) {
      console.log('val------', val)
      // this.arr.forEach((item, index) => {
      //   if (item.type === 'view') {
      //     // eslint-disable-next-line eqeqeq
      //     if (item.sub_button.length == 0) {
      //       item.platform_id = ''
      //       item.url = ''
      //     }
      //   }
      // })
      // this.arr.forEach((item, index) => {
      //   item.sub_button.forEach((items, index) => {
      //     if (item.type === 'view') {
      //       items.platform_id = ''
      //       items.url = ''
      //     }
      //   })
      // })
      // this.linkinput = ''
      // this.urlpalateid = ''
      // this.linkallarr = []
      // this.getlinktypesalllist()
    },
    changetextpalate() {
      this.options = []
      this.addname = ''
      this.getcustomercationtwo()
    },

    changelinkpalate() {
      this.linkoptions = []
      this.webpageright = null
      this.getcustomercationthree()
    },
    // 上传图片回调 图片(不是裁剪上传)
    async uploadPictures(e) {
      console.log('e', e)
      const fileIfon = e.target.files[0]
      console.log('fileIfon', fileIfon)
      const img = new Image()
      const temporary = window.URL.createObjectURL(fileIfon)
      img.src = temporary
      // this.temporary = temporary
      const observable = qiniu.upload(fileIfon, `user/${Math.random().toString(36).slice(-6) + '--' + fileIfon.name}`, this.token, {
        fname: fileIfon.name // 文件名
      }, {
        useCdnDomain: true // cdn域名加速
      })
      observable.subscribe({
        next() { },
        error(err) {
          console.log(err)
        },
        complete: (data) => {
          console.log('上传图片data', data)
          newMaterial({
            type: 1,
            height: img.height,
            width: img.width,
            size: fileIfon.size,
            key: data.key
          }).then(response => {
            console.log(response)
            //             this.obg.img = img
            // this.obg.keys = key

            // if (this.selftype === 'parent') {
            //   this.arr[this.indexinput].media_id = key
            // } else {
            //   this.arr[this.indexinput].sub_button[this.sonindexinput].media_id = key
            // }
            this.obg.img = response.data.path
            this.obg.keys = response.data.sourceMaterialId

            if (this.selftype === 'parent') {
              this.arr[this.indexinput].media_id = response.data.sourceMaterialId
            } else {
              this.arr[this.indexinput].sub_button[this.sonindexinput].media_id = response.data.sourceMaterialId
            }
            this.$message({
              message: '上传成功',
              type: 'success'
            })
          })
        }
      })
    },
    chooseapplets() {
      // 选择小程序弹窗
      this.appletsdialog = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.appletsdialogview.send()
      }, 100)
    },
    appletupdata(item) {
      console.log('item', item)
      this.appletsdialog = false
      this.appletsinput = item.type_name
      this.appletsid = item.mini_program_type
      if (this.selftype === 'parent') {
        this.arr[this.indexinput].mini_program_type = item.mini_program_type
      } else {
        this.arr[this.indexinput].sub_button[this.sonindexinput].mini_program_type = item.mini_program_type
      }
    },
    weicharting(val) {
      if (val === 1) {
        if (this.selftype === 'parent') {
          this.arr[this.indexinput].mini_program_type = 1001
          this.arr[this.indexinput].appid = this.appid
          this.arr[this.indexinput].pagepath = this.pagepath
          this.arr[this.indexinput].url = this.url
        } else {
          this.arr[this.indexinput].sub_button[this.sonindexinput].mini_program_type = 1001
          this.arr[this.indexinput].sub_button[this.sonindexinput].appid = this.appid
          this.arr[this.indexinput].sub_button[this.sonindexinput].pagepath = this.pagepath
          this.arr[this.indexinput].sub_button[this.sonindexinput].url = this.url
        }
      } else {
        if (this.selftype === 'parent') {
          this.arr[this.indexinput].mini_program_type = this.appletsid
          this.arr[this.indexinput].appid = ''
          this.arr[this.indexinput].pagepath = ''
          this.arr[this.indexinput].url = ''
        } else {
          this.arr[this.indexinput].sub_button[this.sonindexinput].mini_program_type = this.appletsid
          this.arr[this.indexinput].sub_button[this.sonindexinput].appid = ''
          this.arr[this.indexinput].sub_button[this.sonindexinput].pagepath = ''
          this.arr[this.indexinput].sub_button[this.sonindexinput].url = ''
        }
      }
      console.log('this.arr', this.arr)
    },
    choosecustomer() {
      if (this.allpalateid === null) {
        this.$message.error('请选择平台')
        return
      }
      this.customerdialogview = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.customerdialogviewall.send(this.allpalateid)
      }, 100)
    },
    kefucallback(val) {
      this.customerdialogview = false
      this.imageobj.imagetextkey = val.customer_message_no
      this.imageobj.imagetexttitle = val.title
      if (this.selftype === 'parent') {
        this.arr[this.indexinput].cserviceobj.picurl = val.customer_message_no
        this.arr[this.indexinput].cserviceobj.title = val.title
        this.arr[this.indexinput].cserviceobj.platform_id = val.platform_id
      } else {
        this.arr[this.indexinput].sub_button[this.sonindexinput].cserviceobj.picurl = val.customer_message_no
        this.arr[this.indexinput].sub_button[this.sonindexinput].cserviceobj.title = val.title
        this.arr[this.indexinput].sub_button[this.sonindexinput].cserviceobj.platform_id = val.platform_id
      }
      // this.imageobj = val
      //  <div><el-tag v-if="imageobj.imagetextkey!=null" style="margin-right:10px">{{ imageobj.imagetextsrc }}</el-tag></div>
    },
    handleCommand(command) {
      console.log('command', command)
      // if (this.allpalateid === null) {
      //   this.$message.error('请选择平台')
      //   return
      // }
      // eslint-disable-next-line eqeqeq
      if (command.identification == 'platform_activity') {
        this.bookctyactivitiesVisible = true
        // eslint-disable-next-line eqeqeq
        if (this.allpalateid == 99) {
          setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
            this.$refs.bookctyactivitiesbox.send(this.urlpalateid, 2)
          }, 100)
        } else {
          setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
            this.$refs.bookctyactivitiesbox.send(this.allpalateid, 2)
          }, 100)
        }
      }
      // eslint-disable-next-line eqeqeq
      if (command.identification == 'red_packet_activity') {
        this.redbao = true
        // eslint-disable-next-line eqeqeq
        if (this.allpalateid == 99) {
          setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
            this.$refs.chooseredbao.send(this.urlpalateid, 2)
          }, 100)
        } else {
          setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
            this.$refs.chooseredbao.send(this.allpalateid, 2)
          }, 100)
        }
      }
      // eslint-disable-next-line eqeqeq
      if (command.identification == 'platform_promotion_link') {
        this.sclink = true
        // eslint-disable-next-line eqeqeq
        if (this.allpalateid == 99) {
          setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
            this.$refs.sclinkview.send(this.urlpalateid)
          }, 100)
        } else {
          setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
            this.$refs.sclinkview.send(this.allpalateid)
          }, 100)
        }
      }

      // eslint-disable-next-line eqeqeq
      if (command.identification == '') {
        // this.arr[this.indexinput].content_source_url = ''
        // this.arr[this.indexinput].content_source_url = command.sign
        this.linkinput = ''
        this.linkinput = this.linkinput.slice(0, this.tiaoblurIndex) + command.sign + this.linkinput.slice(this.tiaoblurIndex)
        if (this.selftype === 'parent') {
        // this.arr[this.indexinput].url = val
          this.arr[this.indexinput].url = ''
          this.arr[this.indexinput].url = this.arr[this.indexinput].url.slice(0, this.tiaoblurIndex) + command.sign + this.arr[this.indexinput].url.slice(this.tiaoblurIndex)
        } else {
        // this.arr[this.indexinput].sub_button[this.sonindexinput].url = val
          this.arr[this.indexinput].sub_button[this.sonindexinput].url = ''
          this.arr[this.indexinput].sub_button[this.sonindexinput].url = this.arr[this.indexinput].sub_button[this.sonindexinput].url.slice(0, this.tiaoblurIndex) + command.sign + this.arr[this.indexinput].sub_button[this.sonindexinput].url.slice(this.tiaoblurIndex)
        }
      }
    },
    // 选择书城活动回调
    callbadwr(item, type) {
      this.bookctyactivitiesVisible = false
      this.linkinput = ''
      this.linkinput = this.linkinput.slice(0, this.tiaoblurIndex) + item.sign + this.linkinput.slice(this.tiaoblurIndex)
      if (this.selftype === 'parent') {
        // this.arr[this.indexinput].url = val
        this.arr[this.indexinput].url = ''
        this.arr[this.indexinput].url = this.arr[this.indexinput].url.slice(0, this.tiaoblurIndex) + item.sign + this.arr[this.indexinput].url.slice(this.tiaoblurIndex)
      } else {
        // this.arr[this.indexinput].sub_button[this.sonindexinput].url = val
        this.arr[this.indexinput].sub_button[this.sonindexinput].url = ''
        this.arr[this.indexinput].sub_button[this.sonindexinput].url = this.arr[this.indexinput].sub_button[this.sonindexinput].url.slice(0, this.tiaoblurIndex) + item.sign + this.arr[this.indexinput].sub_button[this.sonindexinput].url.slice(this.tiaoblurIndex)
      }
    },
    // 选择红包活动回调
    redcallback(item, type) {
      this.redbao = false
      this.linkinput = ''
      this.linkinput = this.linkinput.slice(0, this.tiaoblurIndex) + item.sign + this.linkinput.slice(this.tiaoblurIndex)
      if (this.selftype === 'parent') {
        // this.arr[this.indexinput].url = val
        this.arr[this.indexinput].url = ''
        this.arr[this.indexinput].url = this.arr[this.indexinput].url.slice(0, this.tiaoblurIndex) + item.sign + this.arr[this.indexinput].url.slice(this.tiaoblurIndex)
      } else {
        // this.arr[this.indexinput].sub_button[this.sonindexinput].url = val
        this.arr[this.indexinput].sub_button[this.sonindexinput].url = ''
        this.arr[this.indexinput].sub_button[this.sonindexinput].url = this.arr[this.indexinput].sub_button[this.sonindexinput].url.slice(0, this.tiaoblurIndex) + item.sign + this.arr[this.indexinput].sub_button[this.sonindexinput].url.slice(this.tiaoblurIndex)
      }
    },
    // 选择书城链接
    sclinkcallback(item) {
      this.sclink = false
      // this.arr[this.indexinput].content_source_url = ''
      // this.arr[this.indexinput].content_source_url = item.sign_template_no
      this.linkinput = ''
      this.linkinput = this.linkinput.slice(0, this.tiaoblurIndex) + item.sign_template_no + this.linkinput.slice(this.tiaoblurIndex)
      if (this.selftype === 'parent') {
        // this.arr[this.indexinput].url = val
        this.arr[this.indexinput].url = ''
        this.arr[this.indexinput].url = this.arr[this.indexinput].url.slice(0, this.tiaoblurIndex) + item.sign_template_no + this.arr[this.indexinput].url.slice(this.tiaoblurIndex)
      } else {
        // this.arr[this.indexinput].sub_button[this.sonindexinput].url = val
        this.arr[this.indexinput].sub_button[this.sonindexinput].url = ''
        this.arr[this.indexinput].sub_button[this.sonindexinput].url = this.arr[this.indexinput].sub_button[this.sonindexinput].url.slice(0, this.tiaoblurIndex) + item.sign_template_no + this.arr[this.indexinput].sub_button[this.sonindexinput].url.slice(this.tiaoblurIndex)
      }
    },
    beforeHandleCommand(sign, identification) {
      return {
        'sign': sign,
        'identification': identification
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.accountManagement{
   padding: 30px 60px;
}
.menutop{
  padding: 20px;
  display: flex;
  background-color: #f4f5f9;
  align-items: center;
}
.menutip{
  margin-left: 20px;
}
.menuir{
    font-size: 14px;
    margin-bottom: 5px;
}
.menutxt{
  color: #9a9a9a;
  font-size: 14px;
}
.mainall{
  padding: 0 25px 0px 25px;
  margin-top: 20px;
}
.neimain{
  display: flex;
  background-color: #e0eaf6;
  align-items: center;
  padding: 12px;
  font-size: 14px;
  margin-bottom: 15px;
}
.neitect{
  margin-left: 10px;
}
.mobile_menu_preview{
  width: 294px;
    background-size: contain;
    position: relative;
    width: 317px;
    height: 580px;
    background: transparent url('https://res.wx.qq.com/mpres/htmledition/images/bg/bg_mobile_head_default62cc1e.png') no-repeat 0 0;
    background-position: 0 0;
    border: 1px solid #e7e7eb;
    flex-shrink: 0;
}
.mobile_hd{
      color: #fff;
    text-align: center;
    padding-top: 34px;
    font-size: 15px;
    width: auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-wrap: normal;
    margin: 0 30px;
}
.biodaw{
    bottom: 0;
    left: 0;
    right: 0;
    border-top: 1px solid #e7e7eb;
    background: transparent url('https://qie-online-sale-qiniu.wsandos.com/bg_mobile_foot_default5ea4b7.png') no-repeat 0 0;
   position: absolute;
        width: 100%;
    height: 50px;
line-height: 48px;
}
.bisbox{
  display: flex;
  align-items: center;
  margin-left: 43px;
}
.updataactive{
      border: 1px solid #07c160;
          color: #07c160;
}
.menutext{
  font-size: 14px;
  position: relative;
  /* white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; */
  width: 91px;
  text-align: center;
  /* padding: 0 9px; */
}
.menutextips{
    position: absolute;
    bottom: 58px;
    border: 1px solid #ccc;
    padding: 0px -8px;
    transform: translate(-50%);
    left: 50%;
    width: 90%;
}
.addmenuactive{
    width: 100%;
    text-align: center;
    border: 1px solid #07c160;
    color: #07c160;
}
.addmenunoactive{
  padding-left: 10px;
}
.submenu{
  color: black;
  text-align: center;
  /* padding: 0 0.5em; */
}
.submenuadd{
  color: black;
  text-align: center;
  border-top: 1px solid #e7e7eb;
  padding: 0 0.5em;
}
.edit_box{
  display: flex;
}
.right_editbox{
  margin-left: 30px;
  width: 100%;
  padding: 15px 20px 5px 20px;
  background-color: #f4f5f9;
  border: 1px solid #e7e7eb;
}
.right_nobox{
  margin-left: 30px;
  width: 100%;
  padding: 15px 20px 5px 20px;
  background-color: #f4f5f9;
  border: 1px solid #e7e7eb;
  min-height: 560px;
  text-align: center;
  line-height: 560px;
  color: #9a9a9a;
  font-size: 14px;
}
.right_edittop{
  display: flex;
  justify-content: space-between;
  padding: 9px 0;
  border-bottom: 1px solid #e7e7eb;

}
.right_editvalue{
  font-weight: 400;
  font-size: 14px;
}
.deletetext{
  color: #576b95;
}
.right_editinput{
  display: flex;
  align-items: center;
  margin-top: 30px;
}
.right_inputvalue{
  margin-left: 30px;
}
.right_tips{
  font-size: 14px;
  color: #9a9a9a;
  margin-left: 98px;
  margin-top: 12px;
}
.right_chooseradio{
  display: flex;
  margin-top: 40px;
  align-items: center;
}
.right_radiobox{
  margin-left: 30px;
}
.right_sendmessage{
  width: 100%;
  background-color: white;
  margin-top: 20px;
  border: 1px solid #E7E7EB;
  padding-bottom: 4px;
}
.tab_navs_panel{
  height: 60px;
  background-color: #f6f8f9;
  display: flex;
  align-items: center;
  padding-left: 20px;
}
.active_tab{
  color: #07C160;
}
.chs_tab{
  /* display: flex;
  justify-content: center; */
  /* margin-top: 124px; */
  /* padding-bottom: 90px; */
  padding: 10px;
}
.tabs_item{
  text-align: center;
}
.tabs_mi{
  margin-right: 168px;
}
.img_updata{
  width: 207px;
  margin-left: 20px;
  margin-top: 20px;
}
.link_box{
    padding: 16px 20px;
    border: 1px solid #e7e7eb;
    background-color: #fff;
    margin-top: 20px;
}
.title_ses{
      color: #9a9a9a;
      font-size: 14px;
}
.linew_boxr{
  display: flex;
  align-items: center;
  margin-top: 30px;
  font-size: 14px;
}
.linkcalwe{
   width: 300px;
   margin-left: 20px;
}
.customer_box{
  /* display: flex;
  align-items: center;
  margin-top: 20px;
  margin-left: 20px; */
  padding: 10px;
}
.choose_customer{
  font-size: 14px;
  color: #9a9a9a;
}
.save_box{
  text-align: center;
  margin-top: 30px;
}
.menutemplate_box{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  margin-right: 10px;
}
.choose_textr{
  margin-top: 10px;
}
.link_url{
  margin: 0 10px;
}
.allexamples_box{
  display: flex;
  margin-top: 20px;
  padding: 10px;
}
.examples_rightbox{
  margin-left: 30px;
}
.within_box{
  border: 1px solid #19be6b;
  height: 100%;
  padding: 8px 8px 8px 7px;
}
.imaetext{
  display: flex;
  justify-content: space-between;
}
.se_top{
  margin-top: 14px;
}
.describe_text{
  color: #999999;
}
.examples_rightbox{
  margin-left: 30px;
}
.examples_leftbox{
  width: 258px;
  height: 112px;
  border: 1px solid #dddee1;
  padding: 5px 10px;
}
.input_box{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.uopatatextimg{
  width: 100px;
  height: 100px;
  margin-top: 20px;
}
.exprot_box{
  margin: 10px 0px 0px 10px;
}
.updataimg{
  height: 260px;
}
.add_name{
  margin: 0 10px;
}
.link_biwc{
  display: flex;
  align-items: center;
}
.choose_plate{
  margin: 10px 0px 10px 0px;
}
.subscribeboxwr{
  background-color: white;
  height: 200px;
  margin-top: 10px;
  padding: 20px 0px 0px 20px;
  box-sizing: border-box;
}
.sewrfw_box{
  color: #9a9a9a;
  font-size: 14px;
}
.applet_box{
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.choosemessagewr{
  padding: 20px;
  display: flex;
  align-items: center;
}
.gongwer{
  display: flex;
  align-items: center;
}
</style>
